<div class="wrapper mt-8">
  <div class="container mx-auto px-4">
    <!-- Welcome Card with improved design -->
    <div class="flex flex-wrap px-6 mb-8">
      <div
        class="daisy-card daisy-card-bordered bg-gradient-to-br from-primary/10 to-secondary/10 w-full shadow-lg hover:shadow-xl transition-shadow duration-300"
      >
        <div class="daisy-card-body p-8">
          <div class="flex items-center gap-4">
            <div class="daisy-avatar daisy-placeholder">
              <div
                class="bg-primary text-primary-content rounded-full w-16 h-16"
              >
                <span class="text-2xl">{{ fullName[0] }}</span>
              </div>
            </div>
            <div>
              <p class="text-sm text-base-content/70 mb-1">Welcome back,</p>
              <h2 class="text-3xl font-bold text-base-content">
                {{ fullName }}
              </h2>
              @if (isTutor) {
              <div class="daisy-badge daisy-badge-primary daisy-badge-sm mt-2">
                Instructor
              </div>
              }
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Enhanced Tab Navigation -->
    <div class="flex flex-wrap px-6">
      <div class="w-full">
        <div class="daisy-card bg-base-100 shadow-lg">
          <div class="daisy-card-body p-0">
            <!-- Tab Buttons with improved styling -->
            <div class="p-4 border-b border-base-300">
              <black-ui-tabs>
                <black-tabs-item name="profile">
                  <button
                    class="daisy-btn daisy-btn-sm gap-2"
                    [class.daisy-btn-primary]="isSelected"
                    [class.daisy-btn-ghost]="!isSelected"
                    *blackTabsTrigger="
                      let selectIndex = selectIndex;
                      let isSelected = isSelected
                    "
                    (click)="selectIndex()"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="h-4 w-4"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                      />
                    </svg>
                    Profile
                  </button>
                  <div *blackTabsContent class="p-6">
                    <black-user-profile></black-user-profile>
                  </div>
                </black-tabs-item>

                <!-- @if (isTutor) {
                <black-tabs-item name="accounts">
                  <button
                    class="daisy-btn daisy-btn-sm gap-2"
                    [class.daisy-btn-primary]="isSelected"
                    [class.daisy-btn-ghost]="!isSelected"
                    *blackTabsTrigger="
                      let selectIndex = selectIndex;
                      let isSelected = isSelected
                    "
                    (click)="selectIndex()"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="h-4 w-4"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1"
                      />
                    </svg>
                    Accounts
                  </button>
                  <div *blackTabsContent class="p-6">
                    <black-accounts></black-accounts>
                  </div>
                </black-tabs-item>
                } -->

                <black-tabs-item name="subscriptions">
                  <button
                    class="daisy-btn daisy-btn-sm gap-2"
                    [class.daisy-btn-primary]="isSelected"
                    [class.daisy-btn-ghost]="!isSelected"
                    *blackTabsTrigger="
                      let selectIndex = selectIndex;
                      let isSelected = isSelected
                    "
                    (click)="selectIndex()"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="h-4 w-4"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z"
                      />
                    </svg>
                    Subscriptions
                  </button>
                  <div *blackTabsContent class="p-6">
                    <black-subscription></black-subscription>
                  </div>
                </black-tabs-item>

                <black-tabs-item name="invoices">
                  <button
                    class="daisy-btn daisy-btn-sm gap-2"
                    [class.daisy-btn-primary]="isSelected"
                    [class.daisy-btn-ghost]="!isSelected"
                    *blackTabsTrigger="
                      let selectIndex = selectIndex;
                      let isSelected = isSelected
                    "
                    (click)="selectIndex()"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="h-4 w-4"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M9 14l6-6m-5.5.5h.01m4.99 5h.01M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16l3.5-2 3.5 2 3.5-2 3.5 2z"
                      />
                    </svg>
                    Invoices
                  </button>
                  <div *blackTabsContent class="p-6">
                    <black-invoices></black-invoices>
                  </div>
                </black-tabs-item>
              </black-ui-tabs>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
